if (!customElements.get('blog-post-controls')) {
  customElements.define(
    'blog-post-controls',
    class BlogPostControls extends HTMLElement {
      connectedCallback() {
        this.sectionId = this.dataset.sectionId;
        this.itemsContainer = document.querySelector(`[data-main-blog-items="${this.sectionId}"]`);
        if (!this.itemsContainer) return;

        this.items = Array.from(this.itemsContainer.querySelectorAll('[data-blog-article]'));
        this.emptyState = document.querySelector(`[data-main-blog-empty="${this.sectionId}"]`);
        this.searchInput = this.querySelector('[data-blog-search]');
        this.metafieldFilter = this.querySelector('[data-blog-metafield-filter]');
        this.sortSelect = this.querySelector('[data-blog-sort]');
        this.initialOrder = new Map(this.items.map((item, index) => [item, index]));

        this.addEventListener('input', this.applyControls.bind(this));
        this.addEventListener('change', this.applyControls.bind(this));
        this.applyControls();
      }

      applyControls() {
        const searchTerm = (this.searchInput?.value || '').trim().toLowerCase();
        const metafieldValue = this.metafieldFilter?.value || '';
        const sortValue = this.sortSelect?.value || 'published-desc';
        let visibleCount = 0;

        this.items.forEach((item) => {
          const title = (item.dataset.title || '').toLowerCase();
          const articleMetafield = item.dataset.filterMetafield || '';
          const matchesSearch = !searchTerm || title.includes(searchTerm);
          const matchesMetafield = !metafieldValue || articleMetafield === metafieldValue;
          const isVisible = matchesSearch && matchesMetafield;

          item.hidden = !isVisible;
          if (isVisible) visibleCount += 1;
        });

        this.sortItems(sortValue).forEach((item) => this.itemsContainer.appendChild(item));

        if (this.emptyState) {
          this.emptyState.hidden = visibleCount > 0;
        }
      }

      sortItems(sortValue) {
        return [...this.items].sort((itemA, itemB) => {
          let result = 0;

          if (sortValue === 'title-asc' || sortValue === 'title-desc') {
            result = (itemA.dataset.title || '').localeCompare(itemB.dataset.title || '', undefined, {
              sensitivity: 'base',
            });
          } else {
            const dateA = Number(itemA.dataset.publishedAt || 0);
            const dateB = Number(itemB.dataset.publishedAt || 0);
            result = dateA - dateB;
          }

          if (sortValue === 'title-desc' || sortValue === 'published-desc') {
            result *= -1;
          }

          return result || this.initialOrder.get(itemA) - this.initialOrder.get(itemB);
        });
      }
    }
  );
}
